<div class="bg-white rounded-[20px] p-[28px] h-full shadow-[0px_4px_10px_rgba(20,31,71,0.08)]">
    <div class="flex flex-col gap-8">
        <ng-container *ngFor="let card of cards; let last = last">
            <button
                type="button"
                class="flex items-center gap-3 w-full text-left cursor-pointer bg-transparent border-0 p-0 hover:opacity-80 transition-opacity"
                (click)="openCard(card)">
                <!-- Icon 55×55 -->
                <div class="w-[55px] h-[55px] flex-shrink-0 rounded-xl overflow-hidden">
                    <img [src]="card.iconSrc" alt="" class="w-full h-full" />
                </div>
                <!-- Label + subtitle -->
                <div class="flex flex-col gap-1 flex-1 min-w-0">
                    <div class="flex items-center gap-2">
                        <span class="widget-title text-[#1c1c1c]" style="font-feature-settings:'ss01' 1,'cv01' 1">{{ card.label }}</span>
                        <i class="pi pi-info-circle size-[16px] text-[#787B83]"
                            [pTooltip]="card.description"
                            tooltipPosition="top"></i>
                    </div>
                    <span class="text-xs font-normal text-[#999]">{{ card.description }}</span>
                </div>
                <!-- Count + chevron -->
                <div class="flex items-center gap-3 flex-shrink-0">
                    <span class="text-[44px] font-bold leading-[40px] text-[#111128]">{{ valueFor(card) }}</span>
                    <i class="pi pi-angle-right text-[18px] text-[#999999]"></i>
                </div>
            </button>
            <div *ngIf="!last" class="h-px bg-[#E6E6E6] w-full"></div>
        </ng-container>
    </div>
</div>
